export default function EFIH(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_8373_45705)">
                <path
                    d="M30.8125 35H9.1875C8.25552 35 7.5 34.2445 7.5 33.3125V6.6875C7.5 5.75552 8.25552 5 9.1875 5H30.8125C31.7445 5 32.5 5.75552 32.5 6.6875V33.3125C32.5 34.2445 31.7445 35 30.8125 35Z"
                    stroke="currentColor"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7.5 27.5H32.5" stroke="currentColor" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M25 31.25H28.75" stroke="currentColor" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
                <ellipse cx="1.25" cy="1.25" rx="1.25" ry="1.25" transform="matrix(1 0 0 -1 10 32.5)" fill="currentColor" />
                <circle cx="1.25" cy="1.25" r="1.25" transform="matrix(1 0 0 -1 13.75 32.5)" fill="currentColor" />
                <ellipse cx="1.25" cy="1.25" rx="1.25" ry="1.25" transform="matrix(1 0 0 -1 17.5 32.5)" fill="currentColor" />
                <ellipse cx="7.5" cy="7.5" rx="7.5" ry="7.5" transform="matrix(1 0 0 -1 12.5 23.75)" stroke="currentColor" strokeWidth="1.6875" />
            </g>
            <defs>
                <clipPath id="clip0_8373_45705">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
